import { useTranslation } from "react-i18next";

const Month = ({ month, year, children, isWeek = false }) => {
    const { t } = useTranslation("common");
    return (
        <div className="month">
            <div className="month-header">{month} {year}</div>
            <div className="weekdays">
                <div>{t('calendar.monday')}</div>
                <div>{t('calendar.tuesday')}</div>
                <div>{t('calendar.wednesday')}</div>
                <div>{t('calendar.thursday')}</div>
                <div>{t('calendar.friday')}</div>
                <div>{t('calendar.saturday')}</div>
                <div>{t('calendar.sunday')}</div>
            </div>
                {!isWeek ? (
                    <div className="days">
                        {children}
                    </div>) : (
                    <div className="days">
                        <div className="week">
                            {children}
                        </div>
                    </div>)
                }
        </div>
    );
};

export default Month;
